import React from 'react';
import { isBrowser } from './dom';

// eslint-disable-next-line no-restricted-syntax
export const useEnhancedEffect = isBrowser ? React.useLayoutEffect : React.useEffect;
